const setOOSProducts = (res, items) => {
  const oos = items.filter(item => !res[item.productId].available)
  const updateItems = items.filter(
    item => res[item.productId].available &&
      parseInt(item.quantity, 10) > parseInt(res[item.productId].count, 10),
  )
  if (oos.length || updateItems.length) {
    return true
  }
  return false
}

export default setOOSProducts
